export default "__VITE_ASSET__6721a09c__"